import { render } from "./Aura.html?vue&type=template&id=1ae49296&scoped=true&ts=true&external"
import script from "./Aura.vue?vue&type=script&lang=ts"
export * from "./Aura.vue?vue&type=script&lang=ts"

import "./Aura.scss?vue&type=style&index=0&id=1ae49296&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae49296"]])

export default __exports__